import React, { Component } from 'react';

import { SearchBar } from './styles';
import SearchIcon from '../../../../assets/icons/search-icon.svg';
import PropTypes from 'prop-types';

class AdviserSearch extends Component {
  searchInputRef = React.createRef();
  componentDidMount() {
    if (this.searchInputRef && this.searchInputRef.current) {
      this.searchInputRef.current.focus();
    }
  }
  render() {
    const { accSearch, placeholder, searched, restored } = this.props;
    return (
      <SearchBar
        width={'416px'}
        height={'40px'}
        overflow={true}
        iconTop={'21px'}
        iconRight={'12px'}
        data-test='fa-search-bar'
        ref={this.searchInputRef}
        accSearch={accSearch}
        placeholder={placeholder}
        onPressEnter={() => searched()}
        onChange={(e) => restored(e)}
        suffix={
          <img
            src={SearchIcon}
            onClick={() => searched()}
            alt='search_icon'
            data-test='search-icon'
          />
        }
      />
    );
  }
}
AdviserSearch.propTypes = {
  accSearch: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  restored: PropTypes.func.isRequired,
  searched: PropTypes.func.isRequired,
};
export default AdviserSearch;
